export default __webpack_public_path__ + "static/media/scissorspaw.49dc15fe.png";